import React from "react";
// Customizable Area Start
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Avatar, Box, Popover, Typography } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: "Montserrat !important",
    body1: {
      fontFamily: "Montserrat !important",
      fontSize: "16px !important",
      fontWeight: "500 !important",
      lineHeight: "19.5px !important",
      color: "#1E293B",
    },
  },
});

import SearchTalentController, { Props } from "./SearchTalentController.web";
// Customizable Area End

export default class SearchTalent extends SearchTalentController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      talentList,
      searchPopupId,
      anchorEl,
      open,
      onClose,
      onResultClick,
    } = this.props;

    const availableSpace = this.getAvailableSpaceBelow();
    const maxPopoverHeight = availableSpace > 300 ? 300 : availableSpace; // Limit to a max of 300px
    // Customizable Area End
    return (
      // Customizable Area Start
      <ThemeProvider theme={theme}>
        <Popover
          open={open}
          disableAutoFocus
          id={searchPopupId}
          data-test-id="searchPopover"
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              sx: {
                width: anchorEl ? anchorEl.offsetWidth : "auto",
                boxShadow: "none",
                border: "1px solid #CBD5E1",
                borderRadius: "8px",
                marginTop: "5px",
                padding: "5px",
              },
            },
          }}
        >
          <SearchUserWrapper sx={{ maxHeight: maxPopoverHeight - 5 }}>
            {talentList.length > 0 ? (
              talentList.map((talentInfo) => {
                const {
                  id,
                  attributes: { full_name, user_image_url, roles },
                } = talentInfo;
                return (
                  <SearchUsersContentWrapper
                    data-test-id="search-result"
                    key={`search-${id}`}
                    onClick={() => onResultClick(talentInfo)}
                  >
                    <SearchUserAvatar src={user_image_url} alt={full_name} />
                    <Typography>{`${full_name} (${roles})`}</Typography>
                  </SearchUsersContentWrapper>
                );
              })
            ) : (
              <SearchUsersContentWrapper>
                <Typography data-test-id="empty-search">
                  No results found
                </Typography>
              </SearchUsersContentWrapper>
            )}
          </SearchUserWrapper>
        </Popover>
      </ThemeProvider>
      // Customizable Area End
    );
  }
}

// Customizable Area Start

const SearchUserWrapper = styled(Box)({
  overflowY: "auto",
  maxHeight: "400px",
  "&::-webkit-scrollbar": {
    width: "5px", // ✅ Make scrollbar thin
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#CBD5E1", // ✅ Light gray color
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#A1A1A1", // ✅ Slightly darker on hover
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent", // ✅ Hide scrollbar track
  },
});

const SearchUsersContentWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px",
  cursor: "pointer",
  borderRadius: "5px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
});

const SearchUserAvatar = styled(Avatar)({
  height: "40px",
  width: "40px",
  objectPosition: "top",
});
// Customizable Area End
